import type { CSSProperties } from "react";

export const DEFAULT_LAUNCHER_FRAMING = {
  zoom: 100,
  focalX: 50,
  focalY: 50,
} as const;

export function clampLauncherZoom(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value)
    ? Math.min(300, Math.max(100, Math.round(value)))
    : DEFAULT_LAUNCHER_FRAMING.zoom;
}

export function clampLauncherFocal(value: unknown): number {
  return typeof value === "number" && Number.isFinite(value)
    ? Math.min(100, Math.max(0, Math.round(value)))
    : 50;
}

// Keep the launcher crop consistent between the owner's framing preview and
// the public button. At 100% this is the historical centered object-cover.
export function launcherImageFramingStyle(
  zoom?: unknown,
  focalX?: unknown,
  focalY?: unknown,
): CSSProperties {
  const z = clampLauncherZoom(zoom);
  const x = clampLauncherFocal(focalX);
  const y = clampLauncherFocal(focalY);
  const style: CSSProperties = { objectPosition: `${x}% ${y}%` };
  if (z > 100) {
    style.transform = `scale(${z / 100})`;
    style.transformOrigin = `${x}% ${y}%`;
  }
  return style;
}
